import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 即将跳转... ");

import axios from 'axios';
import { onMounted, ref, onUnmounted } from 'vue';
export default {
  __name: 'App',

  setup(__props) {
    let alumniUrl = ref('/api/front/getUrlLink');
    let url = ref(''); // 跳转地址

    let lefX = ref('');
    let rigX = ref('');
    let topY = ref('');
    let botY = ref('');
    let hasLoading = ref(false);

    const getUrl = () => {
      axios.get(alumniUrl.value).then(result => {
        if (result.data.code == '0') {
          url.value = result.data.data;
          console.log(url.value);
          window.sessionStorage.setItem('urlLink', url.value); // setTimeout(() => {

          window.location.href = url.value;
          hasLoading.value = false; // }, 1000)
        }
      }).catch(err => {
        console.log(err);
      });
    };

    const touchPanel = e => {
      console.log(e);
      console.log(url.value);

      if (e.clientX > lefX.value && e.clientX < rigX.value && e.clientY > topY.value && e.clientY < botY.value) {
        if (!url.value) {
          hasLoading.value = true;
          getUrl();
        }

        console.log('跳转');
      }
    };

    const getScreen = () => {
      // 获取分辨率
      let screenX = window.screen.width;
      let screenY = window.screen.height;
      console.log(screenX, screenY);

      switch (screenX) {
        case 375:
          if (screenY == 667) {
            //iphone6/7/8/se
            lefX.value = 166;
            rigX.value = 330;
            topY.value = 462;
            botY.value = 617;
          }

          if (screenY == 812) {
            // iphoneX
            lefX.value = 166;
            rigX.value = 360;
            topY.value = 541;
            botY.value = 731;
          }

          break;

        case 390:
          // iphone12pro
          lefX.value = 171;
          rigX.value = 369;
          topY.value = 564;
          botY.value = 763;
          break;

        case 414:
          if (screenY == 896) {
            // iphoneXR
            lefX.value = 184;
            rigX.value = 397;
            topY.value = 592;
            botY.value = 809;
          }

          if (screenY == 736) {
            //iphone6/7/8plus
            lefX.value = 184;
            rigX.value = 367;
            topY.value = 504;
            botY.value = 687;
          }

          break;
      }
    };

    onMounted(() => {
      console.log('onMounted', 'url', url.value);
      url.value = window.sessionStorage.getItem('urlLink');
      getScreen(); // 获取机型分辨率

      if (url.value) {
        setTimeout(() => {
          window.location.href = url.value;
        }, 200);
      } else {
        // setTimeout(() => {
        getUrl(); // }, 500)
      }
    });
    onUnmounted(() => {
      console.log('onUnmounted', 'url', url.value);
    });
    return (_ctx, _cache) => {
      const _component_van_loading = _resolveComponent("van-loading");

      return _openBlock(), _createElementBlock("div", {
        class: "box",
        onClick: touchPanel
      }, [_unref(hasLoading) ? (_openBlock(), _createBlock(_component_van_loading, {
        key: 0,
        color: "#cccccc",
        type: "spinner",
        class: "loading",
        vertical: ""
      }, {
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }

};